import { yupResolver } from '@hookform/resolvers/yup';
import type { FieldValues, ResolverOptions } from 'react-hook-form';
import type { Schema } from 'yup';

export const schemaResolver = <T extends FieldValues>(schema: Schema<T>) => {
  return (values: T, context: any, options: ResolverOptions<T>) =>
    yupResolver(schema as any)(
      schema.cast(values, { assert: false }) as any,
      context,
      options
    );
};
